import { useEffect, useMemo, useState } from 'react';
import { post } from 'api';
import { enqueueSnackbar } from 'notistack';
import { useAuth } from 'providers/auth-provider/AuthJwtProvider';

const ModuleAccess = ({ state }) => {
  const { sessionUser } = useAuth();
  const MODULE_TREE = [
    {
      name: 'SUPER_ADMIN',
      label: 'SUPERADMIN',
      children: ['All'],
    },
    {
      name: 'HR',
      label: 'HR',
      children: ['Candidates', 'Users'],
    },
    {
      name: 'ENQUIRY',
      label: 'ENQUIRY',
      children: ['Enquiry'],
    },
    {
      name: 'ACCOUNT',
      label: 'ACCOUNT',
      children: ['Customer', 'PDC', 'TDS'],
    },
    {
      name: 'LIASIONING',
      label: 'LIASIONING',
      children: [
        'Document Managment',
        'GEDA Management',
        'Installation Management',
        'Other Management',
      ],
    },
    {
      name: 'INVENTORY',
      label: 'INVENTORY',
      children: ['Dispatch Management', 'Inventory Listing', 'Inventory Managment', 'Stock Update'],
    },
    {
      name: 'DISPATCH',
      label: 'DISPATCH',
      children: ['Dispatch Management'],
    },
    {
      name: 'INSTALLATION',
      label: 'INSTALLATION',
      children: ['Customer', 'Installation Management', 'Other Management'],
    },
    {
      name: 'SALES_SURVEYOR',
      label: 'SALES SURVEYOR',
      children: ['Surveyor'],
    },
    {
      name: 'SALES_MANAGER',
      label: 'SALES MANAGER',
      children: ['Sales Manager'],
    },
  ];

  // ✅ Extract existing module names from backend
  const existingAccess = useMemo(() => {
    return state?.moduleAccess?.map((mod) => mod.name) || [];
  }, [sessionUser]);

  // ✅ Controlled State of selected modules
  const [selectedModules, setSelectedModules] = useState([]);

  // ✅ Track if anything changed
  const isDirty = useMemo(() => {
    return selectedModules.sort().join(',') !== existingAccess.sort().join(',');
  }, [selectedModules, existingAccess]);

  // ✅ Set initial checked values from sessionUser
  useEffect(() => {
    setSelectedModules(existingAccess);
  }, [existingAccess]);

  // ✅ Toggle parent only
  const handleToggle = (moduleName) => {
    setSelectedModules((prev) => {
      if (prev.includes(moduleName)) {
        return prev.filter((m) => m !== moduleName);
      } else {
        return [...prev, moduleName];
      }
    });
  };

  // ✅ Save handler
  const handleSave = async () => {
    try {
      const res = await post('users/update_module_access', {
        newModules: selectedModules,
        userId: state._id,
      });
      if (res.status == 200) {
        enqueueSnackbar(res.message || 'Modules Updates Successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      } else {
        enqueueSnackbar(res.message || 'Error While Updateing Modules', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error While Updateing Modules', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Module Access</h2>

      {MODULE_TREE.map((module) => (
        <div
          key={module.name}
          style={{
            // border: '1px solid #ddd',
            padding: 5,
            marginBottom: 1,
            // borderRadius: 6,
          }}
        >
          {/* ✅ Parent Checkbox */}
          <label style={{ fontWeight: 'bold' }}>
            <input
              type="checkbox"
              checked={selectedModules.includes(module.name)}
              onChange={() => handleToggle(module.name)}
              style={{ marginRight: 8 }}
            />
            {module.label}
          </label>

          {/* ✅ Children (NO CHECKBOX) */}
          <ul style={{ marginLeft: 25, marginTop: 5, color: '#666' }}>
            {module.children.map((child) => (
              <li key={child}>{child}</li>
            ))}
          </ul>
        </div>
      ))}

      {/* ✅ Save Button only if change happens */}
      <button
        onClick={handleSave}
        disabled={!isDirty}
        style={{
          backgroundColor: isDirty ? '#1976d2' : '#ccc',
          color: '#fff',
          padding: '10px 20px',
          border: 'none',
          cursor: isDirty ? 'pointer' : 'not-allowed',
        }}
      >
        Save Changes
      </button>
    </div>
  );
};

export default ModuleAccess;
